"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fixDisabledAttributeToPseudoStateInCss = exports.fixDisabledAttributeToPseudoStateInAst = exports.consts = void 0;
var tslib_1 = require("tslib");
var consts = tslib_1.__importStar(require("./consts"));
exports.consts = consts;
tslib_1.__exportStar(require("./utils/directives"), exports);
tslib_1.__exportStar(require("./utils/injections"), exports);
var fix_disabled_attribute_1 = require("./utils/transformations/fix-disabled-attribute");
Object.defineProperty(exports, "fixDisabledAttributeToPseudoStateInAst", { enumerable: true, get: function () { return fix_disabled_attribute_1.fixDisabledAttributeToPseudoStateInAst; } });
Object.defineProperty(exports, "fixDisabledAttributeToPseudoStateInCss", { enumerable: true, get: function () { return fix_disabled_attribute_1.fixDisabledAttributeToPseudoStateInCss; } });
tslib_1.__exportStar(require("./fonts"), exports);
tslib_1.__exportStar(require("./inline-modules/inline-modules"), exports);
tslib_1.__exportStar(require("./inline-modules/context"), exports);
tslib_1.__exportStar(require("./extensions"), exports);
//# sourceMappingURL=index.js.map